<template>
    <aside>
        <ul id="slide-out" class="sidenav sidenav-fixed ">
            <li>
                <div class="user-view">
                    <div class="background">
                        <img src="../../assets/usr-background.jpg">
                    </div>
                    <span class="white-text name">{{user.name}}</span>
                    <span class="white-text email">{{user.email}}</span>
                </div>
            </li>
            
            <li class="no-padding">
              <ul class="collapsible collapsible-accordion" ref="dashboardlMnuEl">
                <li>
                  <a class="collapsible-header">Dashboards<i class="material-icons">arrow_drop_down</i></a>
                  <div class="collapsible-body">
                    <ul>
                       <router-link tag="li" active-class="active" to="/" exact><a><i class="material-icons left">view_quilt</i>General</a></router-link>                       
                    </ul>
                  </div>
                </li>
              </ul>
            </li>
             <li v-if="accessTableroComercial||accessTableroOperativo||accessTableroMantenimiento"  class="no-padding">
              <ul class="collapsible collapsible-accordion" ref="juntaSemanalMnuEl">
                <li>
                  <a class="collapsible-header">Junta Semanal<i class="material-icons">arrow_drop_down</i></a>
                  <div class="collapsible-body">
                    <ul>
                       <router-link v-if="accessTableroComercial" tag="li" active-class="active" to="/tablero-comercial/comercial"><a><i class="material-icons left">attach_money</i>Tablero Comercial</a></router-link>
                       <router-link v-if="accessTableroOperativo" tag="li" active-class="active" to="/tablero-operaciones/operaciones"><a><i class="material-icons left">directions_bus</i>Tablero Operaciones</a></router-link>
                       <router-link v-if="accessTableroMantenimiento" tag="li" active-class="active" to="/tablero-operaciones/mantenimiento"><a><i class="material-icons left">build</i>Tablero Mantenimiento</a></router-link>
                       <router-link  tag="li" active-class="active" to="/monitoreo"><a><i class="material-icons left">show_chart</i>Monitoreo Indicadores</a></router-link>
                    </ul>
                  </div>
                </li>
              </ul>
            </li>
            <li v-if="accessRepDirOcupacionTiempo||accessRepDirCobranzaMes||accessRepDirOcupacionFinanciera||accessRepDirOcupacionFamilia"  class="no-padding">
              <ul class="collapsible collapsible-accordion" ref="reporteDirectivoMnuEl">
                <li>
                  <a class="collapsible-header">Reportes Directivos<i class="material-icons">arrow_drop_down</i></a>
                  <div class="collapsible-body">
                    <ul>
                      <router-link v-if="accessRepDirOcupacionTiempo"  tag="li" active-class="active" to="/reportes-directivos/ocupacion"><a><i class="material-icons left">timelapse</i>Ocupación en Tiempo</a></router-link>
                      <router-link v-if="accessRepDirCobranzaMes" tag="li" active-class="active" to="/reportes-directivos/cobranza-mes"><a><i class="material-icons left">credit_card</i>Cobranza por mes</a></router-link>
                      <router-link v-if="accessRepDirOcupacionFinanciera" tag="li" active-class="active" to="/reportes-directivos/ocupacion-financiera"><a><i class="material-icons left">receipt</i>Ocupación Financiera</a></router-link>
                      <router-link v-if="accessRepDirOcupacionFamilia" tag="li" active-class="active" to="/reportes-directivos/ocupacion-familia"><a><i class="material-icons left">insert_chart</i>Ocupación por Familia</a></router-link>
                    </ul>
                  </div>
                </li>
              </ul>
            </li>
             <li  v-if="accessMetas||accessUsuarios"   class="no-padding">
              <ul class="collapsible collapsible-accordion" ref="configlMnuEl">
                <li>
                  <a class="collapsible-header">Configuración<i class="material-icons">arrow_drop_down</i></a>
                  <div class="collapsible-body">
                    <ul>
                       <router-link  v-if="accessMetas" tag="li" active-class="active" to="/metas"><a><i class="material-icons left">show_chart</i>Metas</a></router-link>
                       <router-link v-if="accessUsuarios" tag="li" active-class="active" to="/users"><a><i class="material-icons left">people</i>Usuarios</a></router-link>
                    </ul>
                  </div>
                </li>
              </ul>
            </li>
            
        </ul>
    </aside>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      instanceCollapsibleElements: null
    };
  },
  mounted() {
    const sideNavElem = document.querySelector(".sidenav");
    const instance = M.Sidenav.init(sideNavElem, { edge: "left" });
  },
  updated() {},
  computed: {
    user() {
      return this.$store.getters.user;
    },

    accessTableroComercial() {
      return this.$store.getters.accessList["tablero-comercial"];
    },
    accessTableroOperativo() {
      return this.$store.getters.accessList["tablero-operaciones"];
    },
    accessTableroMantenimiento() {
      return this.$store.getters.accessList["tablero-mantenimiento"];
    },
    accessMetas() {
      return this.$store.getters.accessList.metas;
    },
    accessUsuarios() {
      return this.$store.getters.accessList.usuarios;
    },
    accessRepDirOcupacionTiempo() {
      return this.$store.getters.accessList["rd-ocupacion-tiempo"];
    },
    accessRepDirOcupacionFinanciera() {
      return this.$store.getters.accessList["rd-ocupacion-financiera"];
    },
    accessRepDirOcupacionFamilia() {
      return this.$store.getters.accessList["rd-ocupacion-familia"];
    },
    accessRepDirCobranzaMes() {
      return this.$store.getters.accessList["rd-cobranza-mes"];
    },
    ...mapGetters(["accessList"])
  },

  watch: {
    accessList(value) {
      console.log("triggered accesList", value);
      if (value) {
        setTimeout(() => {
          const instanceJuntaSemanalMnuEl = M.Collapsible.init(
            this.$refs.juntaSemanalMnuEl
          );
          const instanceReporteDirectivoMnuEl = M.Collapsible.init(
            this.$refs.reporteDirectivoMnuEl
          );
          const instanceDashboardlMnuEl = M.Collapsible.init(
            this.$refs.dashboardlMnuEl
          );
          const instanceConfiglMnuEl = M.Collapsible.init(
            this.$refs.configlMnuEl
          );

          instanceDashboardlMnuEl.open();
         
        }, 500);
      }
    }
  }
};
</script>

<style scoped>
.collapsible-accordion li.active a.collapsible-header i {
  -ms-transform: rotate(180deg); /* IE 9 */
  -webkit-transform: rotate(180deg); /* Chrome, Safari, Opera */
  transform: rotate(180deg);
}
.background {
  position: relative;
}
.background:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--primary-light-color-alpha40);
}
.background img {
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
}
.user-view {
  padding: 16px 16px 0;
}

.sidenav .user-view .name {
  margin-top: 8px;
}
</style>

